import MPCustomEvent from '../custom-event-modal/models/custom-event';

/**
 * @typedef CustomEvent { import("../custom-event-modal/models/types").SerializedCustomEvent }
 * @typedef NameMap { import("./types").NameMap }
 * @typedef Composition { import("./types").Composition }
 */

/**
 * @param {CustomEvent} customEvent
 * @param {boolean} isCollectEverythingEvent
 * @param {NameMap} nameMap
 * @returns {Composition}
 */
export function getCustomEventComposition({customEvent}, isCollectEverythingEvent, nameMap) {
  let parts = [];
  if (isCollectEverythingEvent) {
    parts = [{highlight: true, label: `AutoTrack Event: Codeless tracking`}];
  } else if (customEvent.alternatives) {
    customEvent.alternatives.forEach((alt) => {
      // Custom events can be nested
      if (alt.event.startsWith(MPCustomEvent.CUSTOM_EVENT_PREFIX)) {
        const {name} = nameMap[alt.event] || {};
        alt.event = name ? name : `Custom Event`;
      }
    });

    parts = MPCustomEvent.fromSerializedCustomEvent(customEvent).getLabelParts();
  } else {
    // NOTE: This shouldn't happen, but there are a few custom events without alternatives
    parts = [{highlight: false, label: `Empty Custom Event`}];
  }
  return {name: `Custom  Event Definition`, parts};
}
